import {BehaviorSubject, Observable, Subject} from 'rxjs';

export class PersistentFormDialogController<ValueType> {
  private readonly submissionSubject: Subject<ValueType> = new Subject<ValueType>();
  private readonly submittingSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public readonly submissions: Observable<ValueType> = this.submissionSubject.asObservable();
  public readonly submitting: Observable<boolean> = this.submittingSubject.asObservable();

  public submit(value: ValueType): void {
    if (this.submittingSubject.value) return;

    this.submittingSubject.next(true);
    this.submissionSubject.next(value);
  }

  public resetAfterFailure(): void {
    this.submittingSubject.next(false);
  }

  public complete(): void {
    this.submissionSubject.complete();
    this.submittingSubject.complete();
  }
}
